<template>
    <div class="profile-content profile-content__egrn">
        <div class="profile-content-menu" style="font-weight: 400">
            <p @click="egrnStatusHelper = !egrnStatusHelper" class="profile-egrn-status-legend">Расшифровка статуса</p>
            <ul v-if="egrnStatusHelper">
                <li><i class="lnr lnr-sync" title="Выписка заказана (в обработке)"></i> - Выписка заказана (в обработке)</li>
                <li><i class="lnr lnr-download"></i> - Выписка готова, можно скачать</li>
                <li><i class="lnr lnr-checkmark-circle" title="Выписка готова и отправлена"></i> - Выписка готова и отправлена</li>
                <li><i class="lnr lnr-plus-circle" title="Выписка заказана"></i> - Выписка заказана</li>
                <li><i class="lnr lnr-question-circle" title="Неверный кад. номер"></i> - Неверный кад. номер</li>
                <li><i class="lnr lnr-circle-minus" title="Нет данных в Росреестре"></i> - Нет данных в Росреестре</li>
            </ul>
        </div>
        <table class="simple-table desktop">
            <thead>
                <tr>
                    <th></th>
                    <th>Дата</th>
                    <th style="white-space: nowrap">Кадастровый номер</th>
                    <th>Адрес</th>
                    <th>Статус</th>
                </tr>
            </thead>
            <tbody>
                <tr class="simple-table-body-item" v-for="(e,i) in data" :key="i">
                    <td>
                        <i v-if="e.type == 1" title="Обычная выписка" class="uk-icon-file-text"></i>
                        <i v-else-if="e.type == 2" title="Архивная выписка" class="uk-icon-file-text-o"></i>
                        <i v-else-if="e.type == 3" title="Обычная выписка с ЭЦП" class="uk-icon-file"></i>
                        <i v-else-if="e.type == 4" title="Архивная выписка с ЭЦП" class="uk-icon-file-o"></i>
                    </td>
                    <td>{{new Date(e.datetime).toLocaleDateString()}}</td>
                    <td>
                        <span v-if="e.kad_num">{{e.kad_num}}</span>
                    </td>
                    <td class="simple-table-body-item-title">
                        <span v-if="e.address">{{e.address}}</span>
                    </td>
                    <td class="simple-table-body-item-status" style="color: #444">
                        <i v-if="e.status == 0" class="lnr lnr-sync" title="Выписка заказана (в обработке)"></i>
                        <a v-else-if="e.status == 1" :href="e.file_url" target="_blank">
                            <i class="lnr lnr-download"></i>
                        </a>
                        <i v-else-if="e.status == 2" class="lnr lnr-plus-circle" title="Выписка заказана"></i>
                        <i v-else-if="e.status == 3" class="lnr lnr-question-circle" title="Неверный кад. номер"></i>
                        <i v-else-if="e.status == 4" class="lnr lnr-circle-minus" title="Нет данных в Росреестре"></i>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="simple-table mobile">
            <thead>
                <tr>
                    <th style="text-align: center">Статус</th>
                    <th style="white-space: nowrap">Кадастровый номер</th>
                </tr>
            </thead>
            <tbody>
                <tr class="simple-table-body-item" v-for="(e,i) in data" :key="i">
                    <td class="simple-table-body-item-status" style="color: #444">
                        <i v-if="e.status == 0" class="lnr lnr-sync" title="Выписка заказана (в обработке)"></i>
                        <a v-else-if="e.status == 1" :href="e.file_url" target="_blank">
                            <i class="lnr lnr-download"></i>
                        </a>
                        <i v-else-if="e.status == 2" class="lnr lnr-plus-circle" title="Выписка заказана"></i>
                        <i v-else-if="e.status == 3" class="lnr lnr-question-circle" title="Неверный кад. номер"></i>
                        <i v-else-if="e.status == 4" class="lnr lnr-circle-minus" title="Нет данных в Росреестре"></i>
                    </td>
                    <td>
                        <span v-if="e.kad_num">{{e.kad_num}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data: () => ({
        egrnStatusHelper: false
    })
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables.sass'

.simple-table
    th
        text-align: left
    &-body-item-title
        color: #333
        width: 100%
    &-body-item-status
        text-align: center
        font-size: 16px

@media screen and (min-width: $mobile-resolution)
    .mobile
        display: none

@media screen and (max-width: $mobile-resolution)
    .desktop
        display: none
</style>